export default "__VITE_ASSET__OdtPeKt2__"